export function extractDailyPeak(): never {
  throw new Error('daily-peak-register extraction not yet implemented (Batch 2+)');
}
